import React from 'react'
import { Close } from '@mui/icons-material'

type FilterChipProps = {
  filterLabel: string
  displayValue: string
  onRemove: () => void
  isMultiSelect?: boolean
  className?: string
  disabled?: boolean
}

// @purpose Removable chip displaying an active filter's label and value in the global filter bar
const FilterChip = ({
  filterLabel,
  displayValue,
  onRemove,
  className = '',
  disabled = false,
}: FilterChipProps): React.JSX.Element => {
  return (
    <div
      className={`flex items-center gap-2 px-3 h-6 border rounded-md text-sm font-medium ${
        disabled
          ? 'bg-slate-100 dark:bg-slate-800 text-slate-400 dark:text-slate-600 border-slate-200 dark:border-slate-700'
          : 'bg-blue-50 text-blue-700 dark:bg-blue-900/20 dark:text-blue-300 border-blue-200 dark:border-blue-700'
      } ${className}`}
    >
      <span
        className={`text-xs font-medium uppercase ${
          disabled
            ? 'text-slate-400 dark:text-slate-600'
            : 'text-slate-600 dark:text-slate-400'
        }`}
      >
        {filterLabel}:
      </span>
      <span
        title={`${displayValue}`}
        className="font-medium overflow-hidden text-ellipsis whitespace-nowrap max-w-[300px]"
      >
        {displayValue}
      </span>
      <button
        onClick={disabled ? undefined : onRemove}
        disabled={disabled}
        className={`ml-1 flex transition-colors ${
          disabled
            ? 'text-slate-300 dark:text-slate-700 cursor-not-allowed'
            : 'text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300'
        }`}
        aria-label={`Remove ${filterLabel} filter`}
      >
        <Close sx={{ fontSize: 14 }} />
      </button>
    </div>
  )
}

export default FilterChip
